import { Task } from './task'
import { Outline } from './outline'
import { TaskReflection } from './task-reflection'

export interface CourseActivityTaskInterface {
  /**
   * 活动任务
   */
  task?: Task
  outlines?: Outline[]
  /**
   * 前台用户请求接口
   *  - 返回当前用户【活动任务】完成情况
   */
  taskCompletedInfo?: TaskReflection | null
  /**
   * 后台用户请求接口
   *  - 是否有人提交
   */
  isSubmit?: boolean
}

export class CourseActivityTask implements CourseActivityTaskInterface {
  /**
   * 活动任务
   */
  task?: Task
  outlines?: Outline[]
  /**
   * 前台用户请求接口
   *  - 返回当前用户【活动任务】完成情况
   */
  taskCompletedInfo?: TaskReflection | null
  /**
   * 后台用户请求接口
   *  - 是否有人提交
   */
  isSubmit?: boolean

  constructor(props: CourseActivityTaskInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      task: _task,
      outlines: _outlines,
      taskCompletedInfo: _taskCompletedInfo,
      isSubmit: _isSubmit,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.task = _task ? new Task(_task) : _task
    this.outlines = _outlines ? _outlines.map((i) => new Outline(i)) : _outlines
    this.taskCompletedInfo = _taskCompletedInfo
      ? new TaskReflection(_taskCompletedInfo)
      : _taskCompletedInfo
    this.isSubmit = _isSubmit
  }
}
